import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import useSelectSheetRuntime from '@skygroup/shared/components/mobile-select-sheet/useSelectSheetRuntime';
import useScreenWidth from '../../hooks/useScreenSize';
import './mobileSelectSheet.less';

// Phones: the runtime half of the select bottom sheets (mobileSelectSheet.less)
// — mounted once in App, so every Select / TreeSelect / Cascader gets it:
//   • a tap opens the sheet without focusing the field (no keyboard); the
//     sheet's search bar raises it (shared mobile-select-sheet);
//   • a dimmed backdrop while a sheet is open — tapping it closes the select
//     (antd closes on an outside mousedown) without the tap falling through
//     to whatever is under it.

// mirrors the @sheet selector of mobileSelectSheet.less
const OPEN_SHEET =
  'body > div > div > .ant-select-dropdown:not(.ant-select-dropdown-hidden):not(.m-no-sheet):not(.custom-auto-complete-dropdown):not(.guest-name-autocomplete-dropdown):not(.agent-sheet__search-popup):not(.additional-departure-dropdown-options)';

const MobileSelectSheetLayer = () => {
  const { isMobileWidth } = useScreenWidth();
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  useSelectSheetRuntime(isMobileWidth, 'm-no-sheet');

  useEffect(() => {
    if (!isMobileWidth) {
      setIsSheetOpen(false);
      return undefined;
    }
    let frame = 0;
    const check = () => {
      frame = 0;
      setIsSheetOpen(
        Array.from(document.querySelectorAll(OPEN_SHEET)).some(
          (el) => el.getBoundingClientRect().height > 0
        )
      );
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(check);
    };
    check();
    // dropdowns open / close by toggling classes on portaled nodes
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [isMobileWidth]);

  if (!isMobileWidth || !isSheetOpen) return null;
  return createPortal(
    <div className="m-select-sheet-backdrop" aria-hidden="true" />,
    document.body
  );
};

export default MobileSelectSheetLayer;
